import React, { lazy, memo } from 'react';
import { Box, Heading, Text, Link, Stack, Badge, Image } from '@chakra-ui/react';
import { ExternalLink, Clock } from 'lucide-react';
interface ProjectCardProps {
  title: string;
  description: string;
  link: string;
  tools: string[];
  gradient: string;
  image?: string;
  buildTime?: string;
}
export const ProjectCard = memo(function ProjectCard({
  title,
  description,
  link,
  tools,
  gradient,
  image,
  buildTime
}: ProjectCardProps) {
  return <Box borderWidth="1px" borderRadius="lg" overflow="hidden" bg="white" shadow="md" _hover={{
    shadow: 'lg',
    transform: 'translateY(-4px)'
  }} transition="all 0.3s" height="100%" display="flex" flexDirection="column" position="relative" data-id="element-107">
      <Box height="200px" bgGradient={image ? 'none' : gradient} display="flex" alignItems="center" justifyContent="center" overflow="hidden" position="relative" data-id="element-108">
        {image ? <Image src={image} alt={`${title} project screenshot`} width="100%" height="200px" objectFit="cover" loading="lazy" decoding="async" data-id="element-109" /> : <Text fontSize="4xl" fontWeight="bold" color="white" opacity={0.3} data-id="element-110">
            {title.substring(0, 2)}
          </Text>}
        {buildTime && <Badge position="absolute" bottom={3} right={3} colorScheme="purple" display="flex" alignItems="center" gap={1} px={2} py={1} fontSize="xs" data-id="element-111">
            <Clock size={12} aria-hidden="true" data-id="element-112" />
            <span aria-label={`Built in ${buildTime}`} data-id="element-113">{buildTime}</span>
          </Badge>}
      </Box>
      <Box p={6} display="flex" flexDirection="column" flex="1" data-id="element-114">
        <Heading as="h3" size="md" mb={3} data-id="element-115">
          {title}
        </Heading>
        <Text mb={4} color="gray.600" flex="1" data-id="element-116">
          {description}
        </Text>
        <Stack direction="row" flexWrap="wrap" spacing={2} mb={4} data-id="element-117">
          {tools.map((tool, idx) => <Badge key={idx} colorScheme="blue" variant="subtle" px={2} py={1} data-id="element-118">
              {tool}
            </Badge>)}
        </Stack>
        <Link href={link} isExternal color="#1E73BE" fontWeight="semibold" display="flex" alignItems="center" aria-label={`View ${title} project (opens in new tab)`} data-id="element-119">
          View Project{' '}
          <ExternalLink size={16} style={{
          marginLeft: '8px'
        }} aria-hidden="true" data-id="element-120" />
        </Link>
      </Box>
    </Box>;
});